import React from 'react';
import PropTypes from 'prop-types';
import styles from './optionGroupStyles';
import css from './OptionGroup.scss';

const FinishedCornersEdgesOptionGroup = ({ children }) => children.length > 0 && (
<div id="FinishedCornersEdges" className="card-content flex-wrap-dependent-options">
  <h2 className="sticky border" style={styles.border}>
        Finished Corners &amp; Edges
  </h2>
  <div className={`${css.optionGroup} ${css.headless}`}>{children}</div>
</div>
);

FinishedCornersEdgesOptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FinishedCornersEdgesOptionGroup;
